import { useLogin } from '@bnnvara/accounts';
import { useContext } from 'react';

import { BookmarkContext } from './BookmarkContext';

export function useIsBookmarkedByUser(content) {
  const { getIsBookmarkedByUser, toggleBookmark, ids } =
    useContext(BookmarkContext);
  const { login, isLoggedIn } = useLogin();

  const isBookmarkedByUser = getIsBookmarkedByUser(ids, content.id);

  /**
   * This function returns:
   * - `null` when not logged in
   * - `true` when following
   * - `false` when unfollowing
   */
  async function toggle() {
    if (!isLoggedIn) {
      login();

      return null;
    }

    return toggleBookmark(content);
  }

  return {
    ids,
    isBookmarkedByUser,
    toggle,
  };
}
